// extracted by mini-css-extract-plugin
export default {"container":"GenerateToken_container__1jAPh"};